var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 96,
    viewBox: "0 0 86 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.9053 31.8251C63.9053 43.5473 54.3728 53.0418 42.6036 53.0418C30.8343 53.0418 21.3018 43.5473 21.3018 31.8251L21.8876 26.8391L5.32544 18.5646L42.6036 0L79.8817 18.5646V45.0855H74.5562V21.2167L63.3195 26.8391L63.9053 31.8251ZM42.6036 63.6501C66.142 63.6501 85.2071 73.1446 85.2071 84.8669V95.4752H0V84.8669C0 73.1446 19.0651 63.6501 42.6036 63.6501Z",
    fill: "#FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLogoWhite);
export default __webpack_public_path__ + "static/media/studentLogoWhite.4524ac079c5d453ca7f3b9da95c64b5a.svg";
export { ForwardRef as ReactComponent };